import React from 'react';
import { Divider, styled } from '@teko/ds-desktop';
import { ProductCarousel } from '../ProductCarousel/ProductCarousel.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';
import { getImageUrlFromGoogleUserContent } from '../../helpers/image.es.js';
import { BlockHeader } from '../BlockHeader/BlockHeader.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarouselWithHeader = (_a) => {
  var _b = _a, {
    header,
    background,
    dividerColor = "rgba(255, 255, 255, 0.5)",
    style
  } = _b, productCarouselProps = __objRest(_b, [
    "header",
    "background",
    "dividerColor",
    "style"
  ]);
  const { isMobile } = useDevice();
  return /* @__PURE__ */ React.createElement(Wrapper, {
    style: __spreadValues({
      minHeight: isMobile ? "auto" : 416
    }, style),
    background: getImageUrlFromGoogleUserContent(background, {
      width: 1232
    })
  }, header && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BlockHeader, __spreadValues({}, header)), /* @__PURE__ */ React.createElement(Divider, {
    gap: 0,
    color: dividerColor
  })), /* @__PURE__ */ React.createElement(StyledProductCarousel, __spreadValues({}, productCarouselProps)));
};
ProductCarouselWithHeader.displayName = "ProductCarouselWithHeader";
const Wrapper = styled.div`
  ${(props) => props.background && `background-image: url(${props.background});`}
  border-radius: 8px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  min-height: 416px;
`;
const StyledProductCarousel = styled(ProductCarousel)`
  padding: 12px;
`;

export { ProductCarouselWithHeader };
